import { tv } from "@opensea/ui-kit"

export const ACTIVITY_TABLE_COLUMN_CLASSNAMES = {
  event: tv({
    base: "w-[120px] grow",
    variants: {
      variant: {
        item: "first:pl-4",
        global: "",
        profile: "",
        collection: "",
      },
    },
    defaultVariants: {
      variant: "global",
    },
  }),
  item: "w-[calc((100vw-220px-56px))] min-w-[100px] grow md:w-[200px]",
  price: "w-[100px] grow justify-end",
  rarity: "w-[120px] grow justify-end",
  quantity: "w-[70px] grow justify-end",
  from: "min-w-[120px] grow justify-end",
  to: "min-w-[120px] grow justify-end",
  time: tv({
    base: "w-[100px] grow justify-end",
    variants: {
      variant: {
        item: "last:pr-4",
        global: "",
        profile: "",
        collection: "",
      },
    },
    defaultVariants: {
      variant: "global",
    },
  }),
}
